export enum DeprecationMethodId {
  StraightLine = 1,
  DecliningBalance = 2
}

export interface DeprecationMethod {
  id: number
  name: string
}
